/* ============================================================
   SIMOVO FAQ / Help Centre — interactivity (progressive enhancement)
   Server-rendered page; this script adds: global search/filter,
   accordions, sticky jump-nav scroll-spy, install tabs, device checker.
   ============================================================ */
(function () {
  "use strict";

  var TAB_BASE = "flex:1; border:none; cursor:pointer; font-family:'Inter',sans-serif; font-size:14.5px; font-weight:700; padding:11px; border-radius:13px; transition:all .18s;";
  var TAB_ON = TAB_BASE + "background:#fff; color:#2A2118; box-shadow:0 2px 8px rgba(160,120,70,0.12);";
  var TAB_OFF = TAB_BASE + "background:transparent; color:#A0907A;";

  function init(root) {
    if (!root || root.__svoFaq) return;
    root.__svoFaq = true;

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    function stickyPx() {
      var v = getComputedStyle(root).getPropertyValue("--svo-faq-sticky");
      var n = parseInt(v, 10); return isNaN(n) ? 0 : n;
    }
    function jumpH() { var j = $(".svo-faq-jump"); return j ? j.offsetHeight : 48; }
    function scrollToId(id) {
      var el = document.getElementById(id); if (!el) return;
      var y = el.getBoundingClientRect().top + window.scrollY - (stickyPx() + jumpH() + 12);
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    /* ---------- accordions ---------- */
    function setItemOpen(item, open) {
      var body = $(".svo-acc-body", item), chev = $(".svo-acc-chev", item);
      if (body) { body.style.maxHeight = open ? body.querySelector("*") ? body.scrollHeight + "px" : "600px" : "0px"; body.style.opacity = open ? "1" : "0"; }
      if (chev) chev.style.transform = open ? "rotate(180deg)" : "rotate(0deg)";
      item.style.boxShadow = open ? "0 8px 22px rgba(160,120,70,0.10)" : "";
      item.classList.toggle("svo-open", open);
    }
    $$("[data-svo-acc-item]").forEach(function (item) {
      var btn = $("[data-svo-acc-toggle]", item);
      if (btn) btn.addEventListener("click", function () { setItemOpen(item, !item.classList.contains("svo-open")); });
      if (item.hasAttribute("data-open")) { setItemOpen(item, true); }
    });

    /* ---------- global search ---------- */
    var searchInput = $("[data-svo-search]");
    var clearBtn = $("[data-svo-clear]");
    var topics = $("[data-svo-topics]");
    var noResults = $("[data-svo-noresults]");
    var noResultsQ = $("[data-svo-noresults-q]");
    var resultCount = $("[data-svo-resultcount]");
    var installSection = $("[data-svo-install]");
    var accItems = $$("[data-svo-acc-item]");
    var accSections = $$("[data-svo-section]").filter(function (s) { return !s.hasAttribute("data-svo-install"); });

    function itemText(item) {
      var q = $(".svo-q", item), a = $(".svo-a", item);
      return ((q ? q.textContent : "") + " " + (a ? a.textContent : "")).toLowerCase();
    }
    function resetDefault() {
      if (topics) topics.hidden = false;
      $$(".svo-intro").forEach(function (p) { p.style.display = ""; });
      accItems.forEach(function (item, i) {
        item.style.display = "";
        var id = item.getAttribute("data-acc-id");
        setItemOpen(item, id === "gs-0");
      });
      accSections.forEach(function (s) { s.style.display = ""; });
      if (installSection) installSection.style.display = "";
      if (noResults) noResults.hidden = true;
      if (resultCount) resultCount.hidden = true;
    }
    function runSearch() {
      var raw = (searchInput.value || "").trim();
      var q = raw.toLowerCase();
      if (clearBtn) clearBtn.hidden = !raw;
      if (!raw) { resetDefault(); return; }
      if (topics) topics.hidden = true;
      $$(".svo-intro").forEach(function (p) { p.style.display = "none"; });

      var matched = 0;
      accSections.forEach(function (section) {
        var visible = 0;
        $$("[data-svo-acc-item]", section).forEach(function (item) {
          var hit = itemText(item).indexOf(q) > -1;
          item.style.display = hit ? "" : "none";
          if (hit) { visible++; matched++; setItemOpen(item, true); }
        });
        section.style.display = visible ? "" : "none";
      });

      var installHit = false;
      if (installSection) {
        var kw = installSection.getAttribute("data-install-keywords") || "";
        installHit = kw.indexOf(q) > -1;
        installSection.style.display = installHit ? "" : "none";
      }

      var total = matched + (installHit ? 1 : 0);
      if (total === 0) {
        if (noResults) { noResults.hidden = false; if (noResultsQ) noResultsQ.textContent = raw; }
        if (resultCount) resultCount.hidden = true;
      } else {
        if (noResults) noResults.hidden = true;
        if (resultCount) { resultCount.hidden = false; resultCount.textContent = total + " result" + (total === 1 ? "" : "s") + " for \u201C" + raw + "\u201D"; }
      }
    }
    if (searchInput) searchInput.addEventListener("input", runSearch);
    if (clearBtn) clearBtn.addEventListener("click", function () { searchInput.value = ""; runSearch(); searchInput.focus(); });

    /* ---------- jump nav + scroll-spy ---------- */
    var chips = $$("[data-svo-jump].svo-chip");
    $$("[data-svo-jump]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); scrollToId(b.getAttribute("data-svo-jump")); });
    });
    var spyIds = ["getting-started", "install", "using-esim", "unlimited-data", "orders-support", "devices"];
    var raf = null;
    function spy() {
      raf = null;
      var threshold = stickyPx() + jumpH() + 8;
      var cur = spyIds[0];
      spyIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= threshold) cur = id;
      });
      chips.forEach(function (c) { c.classList.toggle("is-on", c.getAttribute("data-svo-jump") === cur); });
    }
    window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(spy); }, { passive: true });

    /* ---------- install tabs ---------- */
    var tabBtns = $$("[data-svo-install-tab]");
    function setTab(which) {
      tabBtns.forEach(function (b) { b.setAttribute("style", b.getAttribute("data-svo-install-tab") === which ? TAB_ON : TAB_OFF); });
      $$("[data-svo-steps]").forEach(function (ol) { ol.hidden = ol.getAttribute("data-svo-steps") !== which; });
      var note = $("[data-svo-note]");
      if (note) note.textContent = which === "iphone"
        ? "If you're viewing the email on the same phone, use the install link rather than scanning the QR code."
        : "Keep a stable Wi-Fi connection while downloading your eSIM. You only need to install it once.";
    }
    tabBtns.forEach(function (b) { b.addEventListener("click", function () { setTab(b.getAttribute("data-svo-install-tab")); }); });

    /* ---------- device checker ---------- */
    var devToggle = $("[data-svo-dev-toggle]");
    var devPanel = $(".svo-dev-panel");
    var devChev = $(".svo-dev-chev");
    var devSearch = $("[data-svo-dev-search]");
    var devBanner = $("[data-svo-dev-banner]");
    var devCount = $("[data-svo-dev-count]");
    var brands = $$(".svo-brand");

    function setDevOpen(open) {
      if (devPanel) devPanel.style.maxHeight = open ? "8000px" : "0px";
      if (devChev) devChev.style.transform = open ? "rotate(180deg)" : "rotate(0deg)";
      root.__devOpen = open;
    }
    function setBrandOpen(brand, open) {
      var body = $(".svo-brand-body", brand), chev = $(".svo-brand-chev", brand);
      if (body) { body.style.maxHeight = open ? body.scrollHeight + "px" : "0px"; body.style.opacity = open ? "1" : "0"; }
      if (chev) chev.style.transform = open ? "rotate(180deg)" : "rotate(0deg)";
      brand.classList.toggle("svo-bopen", open);
    }
    if (devToggle) devToggle.addEventListener("click", function () { setDevOpen(!root.__devOpen); });
    $$("[data-svo-open-devices]").forEach(function (b) {
      b.addEventListener("click", function () { setDevOpen(true); setTimeout(function () { scrollToId("devices"); }, 60); });
    });
    brands.forEach(function (brand) {
      var head = $("[data-svo-brand-toggle]", brand);
      if (head) head.addEventListener("click", function () {
        if (devSearch && devSearch.value.trim()) return; // search controls expansion
        setBrandOpen(brand, !brand.classList.contains("svo-bopen"));
      });
    });
    function runDevSearch() {
      var dq = (devSearch.value || "").trim().toLowerCase();
      var count = 0;
      brands.forEach(function (brand) {
        var models = $$(".svo-model", brand);
        var name = ($("[data-svo-brand-toggle] span span", brand) || {}).textContent || brand.getAttribute("data-brand-id");
        var hits = 0;
        models.forEach(function (chip) {
          var hit = dq && chip.getAttribute("data-model").toLowerCase().indexOf(dq) > -1;
          chip.classList.toggle("is-hit", !!hit);
          if (hit) hits++;
        });
        if (dq) {
          var nameMatch = String(name).toLowerCase().indexOf(dq) > -1;
          if (hits === 0 && !nameMatch) { brand.style.display = "none"; setBrandOpen(brand, false); }
          else { brand.style.display = ""; setBrandOpen(brand, true); count += hits; }
        } else {
          brand.style.display = "";
          setBrandOpen(brand, false);
        }
      });
      if (devBanner) {
        if (dq && count > 0) { devBanner.hidden = false; if (devCount) devCount.textContent = count; }
        else devBanner.hidden = true;
      }
    }
    if (devSearch) devSearch.addEventListener("input", runDevSearch);
  }

  function boot() { document.querySelectorAll(".svo-faq[data-svo-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector ? e.target.querySelector(".svo-faq[data-svo-root]") : null;
    if (r) { r.__svoFaq = false; init(r); }
  });
})();
